{
	"content": {
		"title": "Velg materialene som krever erklæringer",
		"materialListLabel": "Materiale",
		"materialQuantityLabel": "Materialmengde ({{unit}})",
		"availableQuantityLabel": "Tilgjengelig mengde ({{unit}})",
		"carbonSavingsLabel": "Karbonreduksjoner ({{unit}} CO₂-ekv.)"
	},
	"summary": {
		"title": "Sammendrag",
		"declarationTypeTitle": "Erklæringstype",
		"customerProjectTitle": "Kundeprosjekt",
		"internalProjectOrProductTitle": "Internt prosjekt/produkt",
		"projectReferenceTitle": "Prosjektreferanse",
		"materialHeaderTitle": "Materiale",
		"quantityHeaderTitle": "Antall ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Allokerbare karbonreduksjoner ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Ikke-allokerbar karbonreduksjon ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Antall er påkrevd",
		"quantityPositive": "Vennligst skriv inn et positivt antall.",
		"quantityLargerThanAvailable": "Vennligst reduser mengden til totalen tilgjengelig",
		"savingsRequired": "Karbonreduksjoner er nødvendig",
		"fetchNotTransferedMaterialsError": "Kunne ikke hente materialer som ikke ble overført"
	},
	"submitTitle": "Legg til i prosjekt",
	"backTitle": "Tilbake"
}
